
import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';
import '../../assets/css/SliderHome.css';

const UPLOADS_BASE =
  process.env.REACT_APP_UPLOADS_URL ||
  'https://www.businessmateworkflow.in';

const SliderHome = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const touchStartX = useRef(null);
  const touchStartY = useRef(null);

  // Fetch banners from API
  useEffect(() => {
    let isMounted = true;

    const fetchBanners = async () => {
      try {
        const response = await api.get('/banners');

        if (!response.data.success) {
          throw new Error(
            response.data.message || 'Failed to fetch banners'
          );
        }

        const formattedSlides = (response.data.data || []).map(
          (banner) => {
            const titleLines = (banner.title || '').split(
              /<br\s*\/?>/i
            );

            return {
              id: `banner-${banner.id}`,
              bgImage: banner.bgImage
                ? `${UPLOADS_BASE.replace(/\/$/, '')}/uploads/cms/${banner.bgImage.replace(/^\/+/, '')}`
                : '',
              title: titleLines,
              description:
                banner.description ||
                "Startup Business is one of the world's top business consulting firms. We help global leaders with their issues.",
              link: banner.link || '#',
              transition:
                banner.position === 'top'
                  ? 'boxslide'
                  : 'slotzoom-horizontal',
            };
          }
        );

        if (isMounted) {
          setSlides(formattedSlides);
          setActiveSlide(0);
        }
      } catch (err) {
        console.error('Error fetching banners:', err);

        if (isMounted) {
          setError(
            err.response?.data?.message ||
              err.message ||
              'Unable to load banners'
          );
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchBanners();

    return () => {
      isMounted = false;
    };
  }, []);

  // Automatically rotate slides
  useEffect(() => {
    if (slides.length <= 1) return;

    const timer = setInterval(() => {
      setActiveSlide((previous) => (previous + 1) % slides.length);
    }, 8500);

    return () => clearInterval(timer);
  }, [slides.length]);

  // Navigate to the next or previous slide
  const goToSlide = (index) => {
    setActiveSlide((index + slides.length) % slides.length);
  };

  // Support swipe gestures on touch devices
  const handleTouchStart = (event) => {
    const touch = event.touches[0];

    touchStartX.current = touch.clientX;
    touchStartY.current = touch.clientY;
  };

  const handleTouchEnd = (event) => {
    if (
      touchStartX.current === null ||
      touchStartY.current === null ||
      slides.length <= 1
    ) {
      return;
    }

    const touch = event.changedTouches[0];
    const deltaX = touch.clientX - touchStartX.current;
    const deltaY = touch.clientY - touchStartY.current;

    // Only handle clear horizontal swipes
    if (
      Math.abs(deltaX) > 45 &&
      Math.abs(deltaX) > Math.abs(deltaY)
    ) {
      if (deltaX < 0) {
        goToSlide(activeSlide + 1);
      } else {
        goToSlide(activeSlide - 1);
      }
    }

    touchStartX.current = null;
    touchStartY.current = null;
  };

  // Loading state
  if (loading) {
    return (
      <div className="slider-state slider-loading" role="status">
        <p>Loading banners...</p>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="slider-state slider-error" role="alert">
        <p>Error loading banners: {error}</p>
      </div>
    );
  }

  // Empty state
  if (slides.length === 0) {
    return (
      <div className="slider-state slider-empty">
        <p>No active banners available</p>
      </div>
    );
  }

  return (
    <section
      className="rev_slider_wrapper fullwidthbanner-container"
      data-alias="slider4"
      data-source="gallery"
      aria-label="Homepage banners"
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
    >
      <div className="rev_slider fullwidthabanner">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${
              index === activeSlide ? 'active' : ''
            }`}
            aria-hidden={index !== activeSlide}
          >
           
{slide.bgImage && (
  <img
    src={slide.bgImage}
    alt=""
    className="slide-bg-img"
    loading={index === 0 ? 'eager' : 'lazy'}
    draggable={false}
    onLoad={(event) => {
      const img = event.currentTarget;
      const wrapper = img.closest('.fullwidthbanner-container');

      if (wrapper && window.innerWidth <= 480) {
        wrapper.style.setProperty(
          '--banner-height',
          `${(wrapper.clientWidth * img.naturalHeight) / img.naturalWidth}px`
        );
      }
    }}
  />
)}


            {/* Keep the existing banner content structure */}
            <div className="rev_row_zone rev_row_zone_middle">
              <div className="slide-content">
                <div className="tp-caption">
                  <div className="column left"></div>

                  {/*
                  To enable banner text and buttons, uncomment this block:

                  <div className="column center">
                    <h2 className="title">
                      {slide.title.map((line, i) => (
                        <React.Fragment key={i}>
                          {line}
                          {i < slide.title.length - 1 && <br />}
                        </React.Fragment>
                      ))}
                    </h2>

                    <p className="description">
                      {slide.description}
                    </p>

                    <div className="button-group">
                      <a
                        href={slide.link}
                        className="btn btn--rounded btn-secondary"
                      >
                        Learn More
                      </a>
                    </div>
                  </div>
                  */}

                  <div className="column right"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {slides.length > 1 && (
        <div className="slider-dots" aria-label="Slide navigation">
          {slides.map((slide, index) => (
            <button
              key={slide.id}
              type="button"
              className={`dot ${
                index === activeSlide ? 'active' : ''
              }`}
              onClick={() => goToSlide(index)}
              aria-label={`Go to slide ${index + 1}`}
              aria-current={index === activeSlide ? 'true' : undefined}
            />
          ))}
        </div>
      )}
    </section>
  );
};

export default SliderHome;
